import { Separator as e } from "../separator/index.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
// src/design/breadcrumbs/@/components/ellipsis/index.tsx
var r = ({ onExpand: r, ...i }) => /* @__PURE__ */ n("li", {
	className: "font-semibold flex items-center",
	children: [/* @__PURE__ */ t("button", {
		...i,
		className: "border-none bg-transparent p-0 leading-1 text-muted-foreground font-semibold",
		onClick: r,
		type: "button",
		children: "..."
	}), /* @__PURE__ */ t(e, {})]
});
r.displayName = "Ellipsis";
export { r as Ellipsis };

//# sourceMappingURL=index.js.map